import { createStore, applyMiddleware } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import rootReducer from './reducers/index';
import { AppActions } from '../types/store/action';
import { IState } from '../types/store/reducer';

export type AppState = ReturnType<typeof rootReducer>;

const middleware = applyMiddleware(
  thunk as ThunkMiddleware<IState, AppActions>
);


const store = createStore(rootReducer, middleware);

export default store;
